export default __webpack_public_path__ + "static/media/ewwllipse_233.75fa85b3.png";